import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const RelatedProduct = createAsyncThunk(
  "relatedProduct/RelatedProduct",
  async (name, thunkAPI) => {
    const Token = localStorage.getItem("loginData");
    const headers = Token ? { Authorization: `Bearer ${Token}` } : {};

    try {
      const response = await axios.get(`${endPoint.RELATEDPRODUCT}/${name}`, {
        headers: {
          headers,
        },
      });
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const RelatedProductSlice = createSlice({
  name: "RelatedProductData",
  initialState: {
    RelatedProductData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(RelatedProduct.fulfilled, (state, action) => {
        state.RelatedProductData = action.payload;
      })
      .addCase(RelatedProduct.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default RelatedProductSlice.reducer;
